export default "__VITE_ASSET__C8umbM0X__"